import axiosInstance from '../Common/Axios/axiosInstance';
import API from "../Common/Endpoint/serviceConstrants";

export const callSwitchAccountApi = async (payload) => {
  try {
    // Account switch only: keep this separate from active-card balance lookup.
    const serverPayload = { ...(payload || {}), isAccountSwitch: true };
    const { data = [] } = await axiosInstance.post(
      API.switch_AccountApi,
      serverPayload
    );

    return data;
  } catch (error) {
    console.error("Error in callSwitchAccountApi:", error);
    return { errorCode: error?.response?.status || "500", errorMessage: error?.response?.data?.message || "An error occurred" };
  }
};
